module.exports = __webpack_public_path__ + "static/photo-female@2x-38bb5572e1d085848ae573638af2f7ee.jpg";